module.exports = function(app) {
    var attachFileAlertModal = require("chmhom/modals/attachFileAlertModal");
    app.controller("pages.spending.newClaims", ["$scope", "session","services", "storage","coremetrics","spendingResourceServices","$cookies","invisibleForm",'educationalMaterialService', '$window','$timeout',
        function( $scope, session, services, storage, coremetrics, spendingResourceServices, $cookies, invisibleForm, educationalMaterialService, $window, $timeout) {
            $scope.viewState = 'loading';
            $scope.firstMoxieLoad = true;
            var _attachedBytes = 0;
            $scope.deleteChar = String.fromCharCode(215);
            var downloadAttachmentUrl ="/rbsmbl/x-services/download/securemessage/attachment";
            $scope.attachedFiles=[];
            var _attachedFileCounter = 0;

            $scope.resetClaimsForm = function() {
                document.getElementById('newClaims').reset();
            };

            $scope.backAction = function() {
                $window.history.back();
            };
            $scope.cancel = function() {
                $window.location = '/member/spending/receipts';
            };


            //function to initialize moxie plugin for file upload
            var addFile = function () {
                // designate a DOM element as the file picker button
                var fileInput = new mOxie.FileInput({
                    browse_button: 'contactUs-attachFile'
                });
                fileInput.onmousedown = function() {
                    $scope.invalidFileType=false;
                    $scope.fileSizeOverLimit=false;
                    $scope.fileVirusScanError=false;
                    $scope.fileScanTimeoutLI=false;

                };

                // fires when user closes file dialog after a file is selected
                fileInput.onchange = function (evt) {
                    var fileFilter = "application/pdf,image/jpeg,image/tif,image/x-tif,image/tiff,image/x-tiff,application/tif,application/x-tif,application/tiff,application/x-tiff,image/ibm_ondemand";
                    if (evt.target.files && $scope.attachedFiles.length < 1) {

                        // files is a FileList of File objects.
                        for (var i = 0, f; f = evt.target.files[i]; i++) {

                            // check mime type and handle error
                            if (!(f.type.match(fileFilter.replace(/,/g, "|")))) {
                                applyErrorMsg("invalidFileType",true);
                                return;
                            }

                            // If file is greater than 5MB
                            if (f.size > (Math.pow(1024, 2) * 5)) {
                                applyErrorMsg( "fileSizeOverLimit",true);
                                return;
                            }


                            var reader = new mOxie.FileReader();

                            reader.onloadstart = (function (theFile) {

                                return function (e) {
                                    // Increment file counter

                                    _attachedFileCounter++;


                                    var attachment = {
                                        "attachmentId": _attachedFileCounter,
                                        "fileUploadStatus": "pending",
                                        "fileName": theFile.name.toLowerCase(),
                                        "fileSize": theFile.size

                                    };
                                    $scope.attachedFiles.push(attachment);
                                    $scope.confirmDeleteAttachment = function (attachmentName) {

                                        var modalButtons=[
                                            {
                                                buttonLabel:"CANCEL",
                                                buttonClass:"primary",
                                                buttonAction:function(){$scope.closeModal();}
                                            },
                                            {
                                                buttonLabel:"OK",
                                                buttonClass:"primary",
                                                buttonAction:function(){$scope.closeModal();deleteAttachment(attachmentName);}
                                            }
                                        ];

                                        openAttachmentAlertModal('Confirm attachment removal','Are you  sure you want to delete ' + attachmentName.toLowerCase() + '?',modalButtons);

                                    }




                                };
                            })(f);

                            // Closure to capture the file information.
                            reader.onload = (function (theFile) {

                                return function (e) {

                                    $scope.fileBinary = e.target.result;

                                    var binaryOnly = $scope.fileBinary.split(',')[1];

                                    // virus scan
                                    virusScanService.getData(binaryOnly).then(
                                        function(response) {
                                            var parsedResult = response.data;
                                            if (parsedResult && parsedResult.baseMessage && parsedResult.baseMessage.returnCodeDescription === "Virus detected") {
                                                _attachedFileCounter--;
                                                console.log("virus detected");
                                                $scope.attachedFiles[0].fileUploadStatus="failed";
                                                applyErrorMsg("fileVirusScanError",true);
                                            }else{
                                                console.log("no virus detected");
                                                applyErrorMsg("fileVirusScanError",false);
                                                var  fileDetails = {
                                                    "fileData": binaryOnly,
                                                    "strippedFileName": theFile.name.toLowerCase().replace(/[\. ,:-]+/g, "-"),
                                                    "fileUploadStatus":"success",
                                                    "fileType":theFile.type
                                                };
                                                angular.extend($scope.attachedFiles[0],fileDetails);


                                            }
                                        },function(error){
                                            applyErrorMsg("fileScanTimeoutLI",true);
                                        }
                                    );


                                };
                            })(f);

                            // Read in the image file as a data URL.
                            reader.readAsDataURL(f);
                        }
                    }


                };
                // initialize plugin
                fileInput.init();
            };

            $scope.downloadAttachment = function(attachmentId) {
                var downloadAttachment = "";
                if (attachmentId){
                    $scope.attachedFiles.forEach(function (attachment) {
                        if (attachment.attachmentId === attachmentId) {
                            downloadAttachment = attachment;
                        }
                    });
                }
                if(downloadAttachment){
                    /*   window.URL = window.URL || window.webkitURL;
                     var uri = null;

                     window.open(downloadAttachment.scannedFileBinary);
                     uri = window.URL.createObjectURL(base64toBlob.base64toBlob(downloadAttachment.scannedFileBinary, downloadAttachment.fileType));
                     console.log("file uri", uri);*/

                    var byteCharacters = atob(downloadAttachment.fileData);
                    var byteNumbers = new Array(byteCharacters.length);
                    for(var i=0;i<byteCharacters.length;i++){
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var byteArray = new Uint8Array(byteNumbers);
                    var blob = new Blob([byteArray], {type:  downloadAttachment.fileType});



                    var blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl);

                }
            }

            var deleteAttachment=function(attachmentName){
                if (attachmentName) {
                    var index = -1;
                    var fileSize = 0;
                    for (var i = 0; i < $scope.attachedFiles.length; i++) {
                        if (attachmentName === $scope.attachedFiles[i].fileName) {
                            fileSize = $scope.attachedFiles[i].fileSize;
                            index = i;
                            break;
                        }
                    }

                    if (index > -1) {
                        _attachedBytes = _attachedBytes - fileSize;
                        $scope.attachedFiles.splice(index, 1);
                    }
                }
            };



            var openAttachmentAlertModal =function(title,description,buttons){
                $scope.modalTitle = title;
                $scope.modalDescription = description;
                if(buttons){
                    $scope.modalButtons =buttons;
                }else {
                    $scope.modalButtons = [
                        {
                            buttonLabel: "OK",
                            buttonClass: "primary",
                            buttonAction: function () {
                                $scope.closeModal()
                            }
                        }
                    ];
                }
                modal.open({
                    template: require('chmhom/modals/attachFileAlertModal.html'),
                    controller: attachFileAlertModal,
                    scope: $scope
                });
            };

            $scope.closeModal = function(){
                modal.close();
            };

            var applyErrorMsg=function(errorMsgVar,status){
                $scope[errorMsgVar] = status;
                $scope.$apply();
            };



            $timeout(function () {
                if ($scope.firstMoxieLoad) {
                    addFile();
                    $scope.firstMoxieLoad = false;
                }
            }, 1000)

        }])
};